"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = require("react");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var Text_1 = __importDefault(require("shared/components/Text"));
var formatters_1 = require("utils/formatters");
var TextInput_1 = __importDefault(require("../../TextInput"));
var context_1 = require("../context");
var VendorQuoteTextfield = function (_a) {
    var item = _a.item;
    var updateRow = (0, react_1.useContext)(context_1.AnalyserFormContext).updateRow;
    if (item.vendorQuote) {
        (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(TextInput_1.default, { align: "left", alignItems: "flex-start", isNumber: true, onChange: function (e) { return updateRow(item.id, __assign(__assign({}, item), { vendorQuote: e.target.value ? Number(e.target.value.replace(/[^\d.]/g, '')) : undefined })); }, value: item.vendorQuote ? (0, formatters_1.formatMoney)(item.vendorQuote, 'AUD', false, 0, undefined, true) : '', width: "100%" }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ component: "span", pl: 0.5, level: 2, width: "50px" }, { children: "/mo" }))] })));
};
exports.default = VendorQuoteTextfield;
